import React from 'react';
import glamorous from 'glamorous';
import {Button} from '../../../../../common/components';
import HR from '../../HorizontalRule';
import ScrollToMe from '../../../../../common/components/ScrollToMe';
import QuestionGroup from '../QuestionGroup';

const SurveyDetailPage = ({
  color,
  survey,
  responses,
  errors,
  saveQuestionValue,
  onQuestionBlur,
  submitSurvey,
  disableSubmit,
}) => {
  let renderedScroll = false;

  return (
    <div>
      <glamorous.Div marginBottom="2rem">
        <h2>{survey.name}</h2>
        <h4>{survey.description}</h4>
      </glamorous.Div>
      {survey.questionGroups.map((bq, i) => {
        const hasUnanswered = bq.questions.some(
          q => !Object.keys(responses).includes(q.key)
        );
        const shouldRenderScroll = !renderedScroll && hasUnanswered;
        renderedScroll = renderedScroll || shouldRenderScroll;
        return [
          shouldRenderScroll && <ScrollToMe key="scroll" offsetTop={80} />,
          <QuestionGroup
            key={bq.key}
            responses={responses}
            errors={errors}
            onChange={saveQuestionValue}
            onBlur={onQuestionBlur}
            color={color}
            {...bq}
          />,
          survey.questionGroups.length !== i + 1 ? <HR color={color} /> : null,
        ];
      })}
      <Button
        label="Submit"
        style={{ marginTop: '1.25rem' }}
        onClick={submitSurvey}
        disabled={disableSubmit}
      />
    </div>
  );
};

export default SurveyDetailPage;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/DetailPage/ListLayout.js